import type { SupportedLanguage } from './index'

/**
 * Define localized routes here.
 * Each key maps to a route name, with translations for each language.
 *
 * For Chemical Newtech, we keep English URLs for both languages
 * as the company operates primarily in English with Italian as secondary.
 */
export const localizedRoutes = {
  home: {
    it: '',
    en: '',
    es: '',
    de: '',
    fr: '',
  },
  about: {
    it: 'about',
    en: 'about',
    es: 'about',
    de: 'about',
    fr: 'about',
  },
  whistleblowing: {
    it: 'whistleblowing',
    en: 'whistleblowing',
    es: 'whistleblowing',
    de: 'whistleblowing',
    fr: 'whistleblowing',
  },
  cathodicProtection: {
    it: 'cathodic-protection',
    en: 'cathodic-protection',
    es: 'cathodic-protection',
    de: 'cathodic-protection',
    fr: 'cathodic-protection',
  },
  oxygenEvolution: {
    it: 'oxygen-evolution',
    en: 'oxygen-evolution',
    es: 'oxygen-evolution',
    de: 'oxygen-evolution',
    fr: 'oxygen-evolution',
  },
  electrochlorination: {
    it: 'electrochlorination',
    en: 'electrochlorination',
    es: 'electrochlorination',
    de: 'electrochlorination',
    fr: 'electrochlorination',
  },
  hiseochlor: {
    it: 'hiseochlor',
    en: 'hiseochlor',
    es: 'hiseochlor',
    de: 'hiseochlor',
    fr: 'hiseochlor',
  },
  chlorineAlkali: {
    it: 'chlorine-alkali',
    en: 'chlorine-alkali',
    es: 'chlorine-alkali',
    de: 'chlorine-alkali',
    fr: 'chlorine-alkali',
  },
  certifications: {
    it: 'certifications',
    en: 'certifications',
    es: 'certifications',
    de: 'certifications',
    fr: 'certifications',
  },
  contact: {
    it: 'contact',
    en: 'contact',
    es: 'contact',
    de: 'contact',
    fr: 'contact',
  },
  terms: {
    it: 'terms',
    en: 'terms',
    es: 'terms',
    de: 'terms',
    fr: 'terms',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
    es: 'privacy',
    de: 'privacy',
    fr: 'privacy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
